let pbDomain;
const origin = window.location.origin;

switch (true) {
    case origin.includes('localhost'):
        pbDomain = 'http://localhost:3000';
        break;
    case origin.includes('dev'):
        pbDomain = 'https://dev.theprojectbluegroup.com';
        break;
    case origin.includes('stage'):
        pbDomain = 'https://stage.theprojectbluegroup.com';
        break;
    case origin.includes('pre-prod'):
        pbDomain = 'https://pre-prod.theprojectbluegroup.com';
        break;
    case origin.includes('projectblue.com'):
    default:
        pbDomain = 'https://projectblue.com';
        break;
}

export default pbDomain;